<!-- 收货人信息table -->
<template>
    <div>
        <el-table border :header-cell-style="{
            backgroundColor: '#FDEFE7', color: '#000000'
        }" :data="tableData" style="width: 100%">
            <el-table-column fixed="left" align="center" prop="userName" label="收货人(接收订单通知信息的人)" width="190">
            </el-table-column>
            <el-table-column align="center" prop="userPhone" label="手机号码" width="180">
            </el-table-column>
            <el-table-column align="center" label="邮政编码" width="180">
            </el-table-column>
            <el-table-column align="center" prop="address" label="收货地址" width="180">
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import Api from '@/components/Api/index'
export default {
    props: {
        addressId: {}
    },
    components: {},
    data() {
        return {
            tableData: []
        }
    },
    computed: {},
    watch: {
        addressId() {
            this.queryOneAddShippingAddress()
        }
    },
    methods: {
        queryOneAddShippingAddress() {
            if (this.addressId) {
                new Api("user")
                    .queryOneAddShippingAddress(this.addressId)
                    .then((res) => {
                        if (res.status == 200) {
                            this.$set(this.tableData, 0, res.data)
                        } else {
                            this.$message.error({ message: res.statusText });

                        }
                    });
            }
        }
    },
    created() {

    },
}
</script>
<style lang='scss' scoped></style>